import { FilterOption } from './models/filter-option';

export const FILTER_ALL: FilterOption<string> = {
  name: 'All',
  value: 'ALL'
};
export const FILTER_ALL_KEY = 'filter_all';
export const DEFAULT_GROUP_NAME = 'Default Group';
export const DEFAULT_GROUP_KEY = 'default_group';
